var map = {
	"./community-category/index.sync.tsx": 864,
	"./content-curation/HomepageContentCurationContainer.sync.tsx": 865,
	"./header-navigation/index.sync.tsx": 893,
	"./ideation-destination/filters/ProductAreaFilter.sync.tsx": 912,
	"./knowledge-base/index.sync.tsx": 915,
	"./product-updates-destination/ProductUpdatesOverview.sync.tsx": 927,
	"./widget-featured-topics/index.sync.tsx": 388
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1361;